<app-header-detail-property></app-header-detail-property>

<div class="container-fluid container-md">
    <div class="row">
        <div class="col-12 col-md-8">
            <div class="cardBloque mt-2 mb-2">
                <div class="row">
                    <div class="col-12">
                        <swiper class="swiper-paginations swiper-container" [config]="swiperPaginations">
                            <img class="img-responsiva  img-fluid  img-details" *ngFor="let img of property.images" 
                                src="{{ img?.s3Url }}"
                                alt="banner">
                        </swiper>
                    </div>
                </div>
                <!-- <div class="row mt-2">
                    <div class="col-12 col-md-6">
                        Descripción de la propiedad
                    </div>
                    <div class="col-12 col-md-6">
                        <img src="https://t1.uc.ltmcdn.com/es/posts/2/9/6/como_ver_mi_casa_en_google_maps_39692_paso_1_600.jpg"
                            alt="" style="width: 100%;">
                    </div>
                </div> -->

            </div>
        </div>
        <div class="col-12 col-md-4">
            <div class="cardBloque mt-2 mb-2">
                <h2 class="title">{{ property?.announcement_title }}</h2>
                <!-- <h2>Información de contacto</h2>
                <br>
                <h4>Nombre: Edgar Hernandez Cabrera</h4>
                <br>
                <h4>Teléfono: 444 578 1234</h4>
                <br>
                inmobiliaria
                <br>
                <img src="https://alessainmobiliaria.com/wp-content/uploads/2020/09/Alessa-Inmobiliaria-Para-Fondos-Claros.png"
                    alt="" height="50px">
                     -->
                <br>
                <h4 class="title">
                    Caracteristicas de la inmobiliaria
                </h4>
                <h4>Tipo de inmueble: {{ property?.property_type?.name }}</h4>
                <h4 *ngFor="let x of property?.features">* {{ x?.name }}</h4>
                <br>
                <h4 class="title">
                    Información de dirección
                </h4>
                <h4>Estado: {{ property?.location?.state }}</h4>
                <h4>Municipio: {{ property?.location?.municipality }}</h4>
                <br>
                <h4 class="title">
                    Costo
                </h4>
                <h4>Tipo: {{ property?.prices[0]?.property_operation?.name }}</h4>
                <h4>Precio: {{ property?.prices[0]?.amount | currency: 'USD' : 'symbol' : '1.0-0' }} {{ property?.prices[0]?.currency?.name }}</h4>

                <button  class="btn btn-link" (click)="abrirLink(property.external_url)">Mas información</button>
                <share-button button="whatsapp"></share-button>
                <share-button button="facebook"></share-button>


                <!-- <br>
                <h4>Nombre: Edgar Hernandez Cabrera</h4>
                <br>
                <h4>Teléfono: 444 578 1234</h4>
                <br>
                <h4>Compartir propiedad</h4>
                <br>
                Iconos de redes sociales -->

            </div>
        </div>
    </div>
</div>


<app-footer></app-footer>